import React from "react";

import StarsIcon from "@uui/Stars02";
import ThumbsDownIcon from "@uui/ThumbsDown";
import ThumbsUpIcon from "@uui/ThumbsUp";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Row } from "@rui/Stack";
import { Bold } from "@rui/styles";

import { ActionButton } from "./styles";

const OuterWrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.shades.secondary[50],
  padding: theme.spacing(0.5, 1, 0.5, 0.5),
}));

const InnerWrapper = styled(Stack)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.shades.secondary[200]}`,
  paddingLeft: theme.spacing(1),
}));

interface ProposedAnswerProps {
  children: React.ReactNode;
  canEdit: boolean;
  onAccept: () => void;
  onReject: () => void;
}

const ProposedAnswer = ({
  children,
  canEdit,
  onAccept,
  onReject,
}: ProposedAnswerProps) => {
  return (
    <OuterWrapper>
      <InnerWrapper spacing={1}>
        <Typography variant="bodySecondaryReg" color="shades.secondary.800">
          <StarsIcon
            sx={{
              mr: 0.5,
              color: "shades.primary.500",
              fontSize: "12px",
            }}
          />
          <Bold>Proposed Answer:</Bold> {children}
        </Typography>
        {canEdit && (
          <Row spacing={1}>
            <ActionButton
              onClick={onAccept}
              size="small"
              sx={{
                color: "shades.neutral.400",
                height: "fit-content",
                background: "none",
              }}
              variant="text"
              startIcon={<ThumbsUpIcon />}
            >
              Accept
            </ActionButton>
            <ActionButton
              onClick={onReject}
              size="small"
              sx={{
                color: "shades.neutral.400",
                height: "fit-content",
                background: "none",
              }}
              variant="text"
              startIcon={<ThumbsDownIcon />}
            >
              Reject
            </ActionButton>
          </Row>
        )}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default ProposedAnswer;
